/* eslint-env browser */
import page from 'modules/ab-page-js';

export default function register() {
  page('/docs/(.*)?', replace());
}

/**
 * Page.js middleware for path
 * replacing
 *
 * @param {String} path
 * @return {Function} middleware
 * @api private
 */

function replace(path) {
  return function middleware(ctx, next) {
    path = path || ctx.path;
    window.location.replace(path);
  };
}



// WEBPACK FOOTER //
// ./src/pages/docs/docs.js